$.fn.EmbedContainer = function() {
  let self = this
  self.player = self.find('> iframe').get(0).contentWindow
  self.play_btn = self.find('.embed-container__play-btn')

  if (self.data('embed-container')) {
    return self.data('embed-container')
  }

  self.clicked = function() {
    self.play_btn.fadeOut(150)
    self.player.postMessage(JSON.stringify({ method: 'play' }), '*')
  }

  self.calculate_cover = function() {
    if ($.mlmi.mobile.isMobile) {
      self.css('width', '')
    } else {
      self.css('width', self.parent().height() * self.width() / self.height())
    }
  }

  return function() {
    self.data('embed-container', self)
    self.play_btn.on('click', self.clicked)
    if (self.parent().hasClass('page-header__image')) {
      $(window).on('load resize orientationchange', self.calculate_cover)
      self.calculate_cover()
    }
    return self
  }()
}
